var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"panelMensaje",class:_vm.props.clase},[(_vm.props.mensaje)?_c('span',[_vm._v(_vm._s(_vm.props.mensaje))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }